import { render, staticRenderFns } from "./table_projek.vue?vue&type=template&id=4f2bba5a&scoped=true"
import script from "./table_projek.vue?vue&type=script&lang=js"
export * from "./table_projek.vue?vue&type=script&lang=js"
import style0 from "./table_projek.vue?vue&type=style&index=0&id=4f2bba5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2bba5a",
  null
  
)

export default component.exports